// extracted by mini-css-extract-plugin
export var currencyInput = "_k7-1";
export var currencySymbol = "_k7-0";